(function () {
  'use strict';
  function settings() { return window.Station && window.Station.Theme ? window.Station.Theme.config.search : {}; }
  function scope() { return settings().royceScope === 'print' ? 'print' : 'gear'; }
  function cleanQuery(value) {
    var text = String(value || '').trim();
    var prefixes = ['-tag:print-music', 'tag:print-music'];
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      if (text === prefix) return '';
      if (text.indexOf(prefix + ' AND ') === 0) {
        text = text.slice(prefix.length + 5).trim();
        if (text.charAt(0) === '(' && text.charAt(text.length - 1) === ')') text = text.slice(1, -1).trim();
        break;
      }
    }
    // The first phrase keeps generated model queries reversible for filters and headings.
    var original = text.match(/^title:"([^"\\]+)" OR \(\(/);
    return original ? original[1] : text;
  }
  function plainScoped(value, area) {
    var prefix = area === 'print' ? 'tag:print-music' : '-tag:print-music';
    return value ? prefix + ' AND (' + value + ')' : prefix;
  }
  function quoted(value) { return '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; }
  function unique(values) { return values.filter(function (v, i) { return v && values.indexOf(v) === i; }); }
  function compact(value) { return String(value || '').toLowerCase().replace(/[\s_-]+/g, ''); }
  function modelForms(value) {
    var text = value.toLowerCase().replace(/[\u2010-\u2015]/g, '-');
    var joined = text.replace(/[\s-]+/g, '');
    var forms = [text, joined, text.replace(/-/g, ' ')];
    var parts = joined.match(/^([a-z]+)(\d.*)$/i);
    if (parts) forms.push(parts[1] + '-' + parts[2], parts[1] + ' ' + parts[2]);
    var suffix = joined.match(/^([a-z]+)(\d+)([a-z]+)$/i);
    if (suffix) forms.push(suffix[1] + suffix[2] + ' ' + suffix[3], suffix[1] + '-' + suffix[2] + ' ' + suffix[3]);
    return unique(forms);
  }
  function analyse(value) {
    var raw = cleanQuery(value).replace(/\s+/g, ' ').trim();
    var plan = {raw:raw, models:[], words:[], precise:false};
    // Preserve deliberate Shopify syntax and quoted searches instead of rewriting them.
    if (!raw || raw.length > 160 || /[:"\\()*]|\b(?:AND|OR|NOT)\b/.test(raw)) return plan;
    var tokens = raw.replace(/[\u2010-\u2015]/g, '-').split(/\s+/);
    for (var i = 0; i < tokens.length; i++) {
      var word = tokens[i];
      if (/^[a-z]{1,4}$/i.test(word) && i + 1 < tokens.length && /^\d{1,6}[a-z]{0,5}$/i.test(tokens[i + 1])) {
        plan.models.push(word + '-' + tokens[++i]);
      } else if (/[a-z]/i.test(word) && /\d/.test(word) && word.replace(/[^a-z0-9]/gi, '').length >= 3) {
        plan.models.push(word);
      } else if (/^\d{6,14}$/.test(word)) {
        plan.models.push(word);
      } else {
        plan.words.push(word);
      }
    }
    plan.precise = plan.models.length > 0;
    return plan;
  }
  function searchPlan(value, area, broad) {
    var raw = cleanQuery(value), plan = area === 'print' ? {raw:raw, models:[], words:[], precise:false} : analyse(raw);
    if (!plan.precise || broad) { plan.precise = false; plan.query = plainScoped(raw, area); return plan; }
    var clauses = plan.words.map(function (word) { return '(title:' + quoted(word) + ' OR vendor:' + quoted(word) + ')'; });
    plan.models.forEach(function (model) {
      var alternatives = [];
      modelForms(model).forEach(function (form) {
        alternatives.push('title:' + quoted(form), 'variants.sku:' + quoted(form));
        if (/^\d{6,14}$/.test(form)) alternatives.push('variants.barcode:' + quoted(form));
      });
      clauses.push('(' + alternatives.join(' OR ') + ')');
    });
    plan.query = plainScoped('title:' + quoted(plan.raw) + ' OR ((' + clauses.join(' AND ') + '))', area);
    return plan;
  }
  function scopedQuery(value, area) { return searchPlan(value, area, false).query; }
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]; });
  }
  function applyPlan(url, plan, area) {
    url.searchParams.set('q', plan.query);
    if (area === 'print') {
      url.searchParams.set('type', 'product'); url.searchParams.set('view', 'print-music');
    } else if (plan.precise) {
      url.searchParams.set('type', 'product'); url.searchParams.set('options[unavailable_products]', 'show');
    }
    return url;
  }
  function resultsUrl(value) {
    var area = scope(), url = new URL(settings().royceSearchUrl || '/search', window.location.origin);
    applyPlan(url, searchPlan(value, area, false), area);
    if (area === 'print') { url.searchParams.set('filter.v.availability', '1'); url.searchParams.set('options[unavailable]', 'hide'); }
    return url.pathname + url.search;
  }
  function modelMatches(title, model) {
    var chars = compact(model).split('').map(function (c) { return c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return new RegExp('(^|[^a-z0-9])' + chars.join('[\\s_-]*') + '($|[^a-z0-9])', 'i').test(title);
  }
  function productScore(product, plan) {
    var skus = product.skus || [], title = String(product.title || '');
    if (skus.some(function (s) { return compact(s) === compact(plan.raw); })) return 1000;
    if (plan.models.length === 1 && skus.some(function (s) { return compact(s) === compact(plan.models[0]); })) return 900;
    if (compact(title) === compact(plan.raw)) return 800;
    if (plan.models.every(function (m) { return modelMatches(title, m); })) return 600;
    return 100;
  }
  function rankProducts(products, plan) {
    if (!plan.precise) return products;
    return products.map(function (p, i) { return {product:p, index:i, score:productScore(p, plan)}; }).sort(function (a, b) {
      return b.score - a.score || Number(b.product.available) - Number(a.product.available) || a.index - b.index;
    }).map(function (p) { return p.product; });
  }
  function productsAjax(base, config) {
    if (config.royceScope === 'print') return {
      url:base + 'search', dataType:'json', path:'resources.results.products',
      data:{q:plainScoped('{{query}}', 'print'), type:'product', view:'royce-suggestions', options:{prefix:'last', unavailable_products:config.showUnavailableProducts}}
    };
    return function (query) {
      var plan = searchPlan(query, 'gear', false);
      return {
        url:base + 'search', dataType:'json', path:'resources.results.products',
        data:{q:plan.query, type:'product', view:'royce-suggestions', sort_by:'relevance', options:{prefix:'last', unavailable_products:plan.precise ? 'show' : config.showUnavailableProducts}},
        callback:{done:function (response) {
          if (response && response.resources && response.resources.results) response.resources.results.products = rankProducts(response.resources.results.products || [], plan).slice(0, 5);
          return response;
        }}
      };
    };
  }
  window.RoyceSearch = {scopeQuery:scopedQuery, cleanQuery:cleanQuery, resultsUrl:resultsUrl, productsAjax:productsAjax, escapeHtml:escapeHtml, searchPlan:searchPlan, rankProducts:rankProducts};
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!form || !form.querySelector || (form.hasAttribute && form.hasAttribute('data-rp-search'))) return;
    var query = form.querySelector('[name="q"]'); if (!query) return;
    var action = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
    var searchPath = new URL(settings().royceSearchUrl || '/search', window.location.origin).pathname;
    var isFacet = form.closest && form.closest('faceted-filters-form');
    if (action.pathname !== searchPath && !isFacet) return;
    var currentQuery = String(query.value || '').trim(), area = scope();
    if (area === 'print') {
      event.formData.set('q', /^tag:print-music(?:\s|$)/.test(currentQuery) ? currentQuery : scopedQuery(currentQuery, area));
      event.formData.set('type', 'product'); event.formData.set('view', 'print-music');
      if (form.closest('#app-header') || form.classList.contains('rm-mobile-search')) { event.formData.set('filter.v.availability', '1'); event.formData.set('options[unavailable]', 'hide'); }
    } else {
      var broad = !!isFacet && new URL(window.location.href).searchParams.get('rm_broad') === '1';
      var plan = searchPlan(currentQuery, area, broad); event.formData.set('q', plan.query);
      if (broad) event.formData.set('rm_broad', '1');
      if (plan.precise) { event.formData.set('type', 'product'); event.formData.set('options[unavailable_products]', 'show'); }
    }
  }, true);
  var current = new URL(window.location.href);
  var searchPath = new URL(settings().royceSearchUrl || '/search', window.location.origin).pathname;
  var printFilterPage = scope() === 'print' && current.searchParams.get('view') === 'print-music';
  if (!printFilterPage && current.pathname === searchPath && current.searchParams.has('q') && current.searchParams.get('view') !== 'royce-suggestions') {
    var canonical = new URL(current.href);
    applyPlan(canonical, searchPlan(current.searchParams.get('q'), scope(), current.searchParams.get('rm_broad') === '1'), scope());
    if (canonical.href !== current.href) window.location.replace(canonical.pathname + canonical.search + canonical.hash);
  }
  function enhanceResults() {
    var locationNow = new URL(window.location.href);
    if (scope() === 'print' || locationNow.pathname !== searchPath) return;
    var plan = searchPlan(locationNow.searchParams.get('q'), 'gear', locationNow.searchParams.get('rm_broad') === '1');
    if (!plan.precise) return;
    var panel = document.querySelector('[data-rm-search-results]');
    if (panel && (!locationNow.searchParams.get('sort_by') || locationNow.searchParams.get('sort_by') === 'relevance')) {
      var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-rm-product]'));
      var ranked = rankProducts(cards.map(function (card) { return {title:card.getAttribute('data-rm-title'), skus:(card.getAttribute('data-rm-skus') || '').split('|'), available:card.getAttribute('data-rm-available') === 'true', card:card}; }), plan);
      if (ranked.some(function (p, i) { return p.card !== cards[i]; })) ranked.forEach(function (p) { panel.appendChild(p.card); });
    }
    var notice = document.querySelector('[data-rm-search-notice]');
    if (notice && !notice.hasChildNodes()) {
      var broader = new URL(window.location.href); broader.searchParams.set('q', plainScoped(plan.raw, 'gear')); broader.searchParams.set('rm_broad', '1'); broader.searchParams.delete('page');
      var link = document.createElement('a'); link.href = broader.pathname + broader.search; link.className = 'underlined-link'; link.textContent = 'Search more broadly';
      notice.appendChild(document.createTextNode(Number(notice.getAttribute('data-rm-result-count')) === 0 ? 'No exact model matches. ' : 'Looking for something else? ')); notice.appendChild(link); notice.hidden = false;
    }
  }
  function initResults() {
    enhanceResults();
    var grid = document.querySelector('#SearchProductGrid');
    if (grid && typeof MutationObserver !== 'undefined') new MutationObserver(enhanceResults).observe(grid, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initResults); else initResults();
})();
